import emptySliceApi from '../../store/emptyApiSlice';
import { UserSettings } from '../../models/UserSettings';
import { UserPreference } from '../../models/UserPreference';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserPreferences: builder.query<UserPreference, void>({
      query: () => `/userpreferences`,
      providesTags: ['UserPreference'],
    }),
    updateUserSettings: builder.mutation<void, UserSettings | null>({
      query: (data: UserSettings) => ({
        url: `/userpreferences/usersettings`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['UserPreference'],
    }),
  }),
});

export const { useGetUserPreferencesQuery, useUpdateUserSettingsMutation } =
  apiSlice;
